import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="copy-primary-attendee"
// On checkbox toggle, copies the email from the primary attendee box
// (data-primary-attendee-box) into this attendee's email field.
// Unchecking clears the email so the user can type a fresh value.
export default class extends Controller {
  static targets = ["email"]

  toggle(event) {
    if (!this.hasEmailTarget) return

    if (event.currentTarget.checked) {
      const primaryBox = document.querySelector('[data-primary-attendee-box="true"]')
      const source = primaryBox?.querySelector('[data-attendee-field="email"]')
      this.#assign(this.emailTarget, source?.value)
      this.emailTarget.readOnly = true
    } else {
      this.emailTarget.readOnly = false
      this.#assign(this.emailTarget, "")
      this.emailTarget.focus()
    }
  }

  #assign(target, value) {
    target.value = value ?? ""
    target.dispatchEvent(new Event("input", { bubbles: true }))
    target.dispatchEvent(new Event("change", { bubbles: true }))
  }
}
